import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bdfaeff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sizes-list" }
const _hoisted_2 = {
  key: 0,
  class: "sizes-list__title"
}
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "item-sizes__icon" }
const _hoisted_5 = { class: "item-sizes__title" }
const _hoisted_6 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-sizes__divider" }, "×", -1))
const _hoisted_8 = ["onClick", "onKeyup"]
const _hoisted_9 = { class: "d-flex align-center" }
const _hoisted_10 = { class: "item-sizes__icon" }
const _hoisted_11 = { class: "item-sizes__title" }
const _hoisted_12 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-sizes__divider" }, "×", -1))
const _hoisted_14 = { class: "sizes-list__items" }
const _hoisted_15 = { class: "d-flex align-center" }
const _hoisted_16 = { class: "item-sizes__icon" }
const _hoisted_17 = { class: "item-sizes__title" }
const _hoisted_18 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-sizes__divider" }, "×", -1))
const _hoisted_20 = ["onClick", "onKeyup"]
const _hoisted_21 = { class: "d-flex align-center" }
const _hoisted_22 = { class: "item-sizes__icon" }
const _hoisted_23 = { class: "item-sizes__title" }
const _hoisted_24 = { class: "item-sizes__sizes d-flex align-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-sizes__divider" }, "×", -1))

import { computed, onMounted, ref, watch, PropType } from 'vue';
import { storeToRefs } from 'pinia';
import i18n from '@/plugins/i18n';

import { useCommonStore } from '@/store/common';
import { useEditorStore } from '@/store/editor';

import { ISize } from '@/types/ISize';
import { sizesRu } from '@/data/sizes/sizesRu';
import { sizesEn } from '@/data/sizes/sizesEn';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';
import AiBottomModal from '@/components/UI/AiBottomModal/AiBottomModal.vue';
import AiLocked from '@/components/UI/AiLocked/AiLocked.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SizesList',
  props: {
  height: {
    type: Number as PropType<number>,
    required: true,
  },
  width: {
    type: Number as PropType<number>,
    required: true,
  },
},
  emits: ['update:width', 'update:height'],
  setup(__props, { emit: emits }) {

const props = __props;

const sizes = ref<ISize[]>([]);





const { isMobile } = storeToRefs(useCommonStore());
const { generateImageData } = storeToRefs(useEditorStore());

const selectedSize = ref<string>('');
const selectedItemKey = ref<number>(-2);
const customWidth = ref<number | null>(null);
const customHeight = ref<number | null>(null);
const showSizesModal = ref<boolean>(false);
const selectRef = ref<any | null>(null);

const lang = computed(() => i18n.global.locale.value);

const selectSizeHandler = (item: ISize, key: number): void => {
  if ((item.width > 0 && item.height > 0) || (item.width === 0 && item.height === 0)) {
    selectedSize.value = `${item.width} × ${item.height}`;
    selectedItemKey.value = key;
    emits('update:width', item.width);
    emits('update:height', item.height);
    showSizesModal.value = false;
  }
};

const toggleSizesModalHandler = (): void => {
  showSizesModal.value = !showSizesModal.value;
};

const sizesWatcher = (): void => {
  selectedSize.value = `${props.width} × ${props.height}`;
  const elemIndex = sizes.value.findIndex((size: ISize) => size.width === props.width && size.height === props.height);
  if (elemIndex !== -1) {
    selectSizeHandler(sizes.value[elemIndex], elemIndex);
    customWidth.value = null;
    customHeight.value = null;
  } else {
    selectSizeHandler({ width: props.width, height: props.height }, -1);
    customWidth.value = props.width > 512 ? 512 : props.width;
    customHeight.value = props.height > 512 ? 512 : props.height;
  }
};

const selectFocusedHandler = (): void => {
  if (isMobile.value) {
    showSizesModal.value = true;
    selectRef.value.menu = false;
  }
};

onMounted(() => {
  sizes.value = lang.value === 'ru' ? sizesRu : sizesEn;
  const { canvas } = generateImageData.value;
  const sizeIndex = sizes.value.findIndex(
    (size: ISize) => size.width === canvas.width && size.height === canvas.height,
  );
  if (sizeIndex !== -1) {
    selectSizeHandler(sizes.value[sizeIndex], sizeIndex);
    customWidth.value = null;
    customHeight.value = null;
  } else {
    selectSizeHandler(sizes.value[0], 0);
  }
});

watch(
  () => props.height,
  () => {
    sizesWatcher();
  },
);
watch(
  () => props.width,
  () => {
    sizesWatcher();
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('editor.settings.size-title')), 1))
      : _createCommentVNode("", true),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_v_spacer, { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_select, {
      eager: "",
      modelValue: selectedSize.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedSize).value = $event)),
      items: sizes.value,
      "hide-details": "",
      class: _normalizeClass(["select-size", { 'select-size--mobile': _unref(isMobile) }]),
      "menu-icon": "mdi-chevron-down",
      "menu-props": { class: 'sizes-menu' },
      "onUpdate:menu": selectFocusedHandler,
      ref_key: "selectRef",
      ref: selectRef
    }, {
      "prepend-item": _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["item-sizes d-flex align-center", { 'item-sizes--active': selectedItemKey.value === -1 }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (selectSizeHandler({ width: customWidth.value || -1, height: customHeight.value || -1 }, -1))),
          onKeyup: _cache[4] || (_cache[4] = ($event: any) => (selectSizeHandler({ width: customWidth.value || -1, height: customHeight.value || -1 }, -1)))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_inline_svg, {
                class: "stroke",
                src: require('@/assets/icons/sizes/custom.svg')
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('editor.settings.custom')), 1)
          ]),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_text_field, {
              modelValue: customWidth.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customWidth).value = $event)),
              modelModifiers: { number: true, lazy: true },
              class: "item-sizes__input",
              "hide-details": "",
              height: "18",
              onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["stop"]), ["tab"]))
            }, null, 8, ["modelValue"]),
            _hoisted_7,
            _createVNode(_component_v_text_field, {
              modelValue: customHeight.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((customHeight).value = $event)),
              modelModifiers: { number: true, lazy: true },
              class: "item-sizes__input",
              "hide-details": ""
            }, null, 8, ["modelValue"])
          ])
        ], 34)
      ]),
      item: _withCtx(({ index, item, props }) => [
        _createElementVNode("div", _mergeProps({
          class: [{ 'item-sizes--active': selectedItemKey.value === index }, "item-sizes d-flex align-center"]
        }, props, {
          onClick: ($event: any) => (selectSizeHandler(item.value, index)),
          onKeyup: ($event: any) => (selectSizeHandler(item.value, index))
        }), [
          (item.value.width > 512 || item.value.height > 512)
            ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (item.value.width > item.value.height)
                ? (_openBlock(), _createBlock(_component_inline_svg, {
                    key: 0,
                    class: "fill",
                    src: require('@/assets/icons/sizes/horisontal.svg')
                  }, null, 8, ["src"]))
                : (item.value.width < item.value.height)
                  ? (_openBlock(), _createBlock(_component_inline_svg, {
                      key: 1,
                      class: "fill",
                      src: require('@/assets/icons/sizes/vertical.svg')
                    }, null, 8, ["src"]))
                  : (_openBlock(), _createBlock(_component_inline_svg, {
                      key: 2,
                      class: "fill",
                      src: require('@/assets/icons/sizes/square.svg')
                    }, null, 8, ["src"]))
            ]),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.value.name), 1)
          ]),
          _createVNode(_component_v_spacer),
          _createElementVNode("div", _hoisted_12, [
            _createTextVNode(_toDisplayString(item.value.width) + " ", 1),
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(item.value.height), 1)
          ])
        ], 16, _hoisted_8)
      ]),
      _: 1
    }, 8, ["modelValue", "items", "class"]),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(AiBottomModal, {
          key: 2,
          "show-modal": showSizesModal.value,
          "handle-toggle": toggleSizesModalHandler,
          title: _ctx.$t('editor.settings.size-title')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(AiClearButton, {
                class: _normalizeClass(["item-sizes d-flex align-center", { 'item-sizes--active': selectedItemKey.value === -1 }]),
                onClick: _cache[12] || (_cache[12] = ($event: any) => (selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1)))
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_inline_svg, {
                        class: "stroke",
                        src: require('@/assets/icons/sizes/custom.svg')
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('editor.settings.custom')), 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_v_text_field, {
                      onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                      onBlur: _cache[7] || (_cache[7] = ($event: any) => (selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1))),
                      modelValue: customWidth.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((customWidth).value = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "item-sizes__input",
                      "hide-details": "",
                      height: "18"
                    }, null, 8, ["modelValue"]),
                    _hoisted_19,
                    _createVNode(_component_v_text_field, {
                      onClick: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["stop"])),
                      onBlur: _cache[10] || (_cache[10] = ($event: any) => (selectSizeHandler({ width: customWidth.value || 100, height: customHeight.value || 100 }, -1))),
                      modelValue: customHeight.value,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customHeight).value = $event)),
                      modelModifiers: { number: true, lazy: true },
                      class: "item-sizes__input",
                      "hide-details": ""
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _: 1
              }, 8, ["class"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizes.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([{ 'item-sizes--active': selectedItemKey.value === index }, "item-sizes d-flex align-center"]),
                  onClick: ($event: any) => (item.width > 512 || item.height > 512 ? null : selectSizeHandler(item, index)),
                  onKeyup: ($event: any) => (item.width > 512 || item.height > 512 ? null : selectSizeHandler(item, index))
                }, [
                  (item.width > 512 || item.height > 512)
                    ? (_openBlock(), _createBlock(AiLocked, { key: 0 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      (item.width > item.height)
                        ? (_openBlock(), _createBlock(_component_inline_svg, {
                            key: 0,
                            class: "fill",
                            src: require('@/assets/icons/sizes/horisontal.svg')
                          }, null, 8, ["src"]))
                        : (item.width < item.height)
                          ? (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 1,
                              class: "fill",
                              src: require('@/assets/icons/sizes/vertical.svg')
                            }, null, 8, ["src"]))
                          : (_openBlock(), _createBlock(_component_inline_svg, {
                              key: 2,
                              class: "fill",
                              src: require('@/assets/icons/sizes/square.svg')
                            }, null, 8, ["src"]))
                    ]),
                    _createElementVNode("div", _hoisted_23, _toDisplayString(item.name), 1)
                  ]),
                  _createVNode(_component_v_spacer),
                  _createElementVNode("div", _hoisted_24, [
                    _createTextVNode(_toDisplayString(item.width) + " ", 1),
                    _hoisted_25,
                    _createTextVNode(" " + _toDisplayString(item.height), 1)
                  ])
                ], 42, _hoisted_20))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["show-modal", "title"]))
      : _createCommentVNode("", true)
  ]))
}
}

})